import BarcodeScan from 'assets/kiosk_graphics/barcode_scan.png';
import CityPassLogo from 'assets/kiosk_graphics/CityPASS_Logo.png';
import CreditCardPayment from 'assets/kiosk_graphics/credit_card_payment.svg';
import CustomLookup from 'assets/kiosk_graphics/custom_lookup.png';
import EmailTicket from 'assets/kiosk_graphics/EmailTicket.png';
import FoodAndDrink from 'assets/kiosk_graphics/food-and-drink.png';
import PrintTicket from 'assets/kiosk_graphics/PrintTicket.png';
import PurchaseIcon from 'assets/kiosk_graphics/purchase_icon.png';
import SearchIcon from 'assets/kiosk_graphics/search_icon.png';
import TextTicket from 'assets/kiosk_graphics/TextTicket.png';
import TicketsIcon from 'assets/kiosk_graphics/tickets_icon.png';
import WillCallIcon from 'assets/kiosk_graphics/will_call_icon.png';
import { KioskGraphics, KioskGraphicSlot } from './types';

// size of the image area in the shared tile component (start menu, delivery and lookup tiles)
const TILE_RESOLUTION = 'Landscape: 352px by 220px \nPortrait: 240px by 220px';
// larger of the delivery tile and the email/text delivery screen (4:3, fills the image column)
const DELIVERY_SCREEN_RESOLUTION = 'Landscape: 580px by 435px \nPortrait: 600px by 450px';

/**
 * Fixed list of kiosk graphics that can be customized (KK-4916).
 * `key` is stored as the media record name and must match the slot keys used by kis-kiosk.
 * Defaults are copies of the graphics bundled with kis-kiosk.
 */
export const KIOSK_GRAPHIC_SLOTS: KioskGraphicSlot[] = [
  {
    key: KioskGraphics.START_PURCHASE,
    label: 'Start Menu – Purchase Tickets',
    defaultSrc: PurchaseIcon,
    defaultFileName: 'purchase_icon.png',
    recommendedResolution: TILE_RESOLUTION
  },
  {
    key: KioskGraphics.START_DONATIONS,
    label: 'Start Menu – Donations',
    defaultSrc: PurchaseIcon,
    defaultFileName: 'purchase_icon.png',
    recommendedResolution: TILE_RESOLUTION
  },
  {
    key: KioskGraphics.START_WILL_CALL,
    label: 'Start Menu – Will Call',
    defaultSrc: WillCallIcon,
    defaultFileName: 'will_call_icon.png',
    recommendedResolution: TILE_RESOLUTION
  },
  {
    key: KioskGraphics.START_INFO,
    label: 'Start Menu – Info',
    defaultSrc: FoodAndDrink,
    defaultFileName: 'food-and-drink.png',
    recommendedResolution: TILE_RESOLUTION
  },
  {
    key: KioskGraphics.START_SOUVENIR,
    label: 'Start Menu – Souvenir',
    defaultSrc: TicketsIcon,
    defaultFileName: 'tickets_icon.png',
    recommendedResolution: TILE_RESOLUTION
  },
  {
    key: KioskGraphics.START_CITYPASS,
    label: 'Start Menu – CityPASS',
    defaultSrc: CityPassLogo,
    defaultFileName: 'CityPASS_Logo.png',
    recommendedResolution: TILE_RESOLUTION
  },
  {
    key: KioskGraphics.DELIVERY_EMAIL,
    label: 'Delivery – Email',
    defaultSrc: EmailTicket,
    defaultFileName: 'EmailTicket.png',
    recommendedResolution: DELIVERY_SCREEN_RESOLUTION
  },
  {
    key: KioskGraphics.DELIVERY_SMS,
    label: 'Delivery – Text Message',
    defaultSrc: TextTicket,
    defaultFileName: 'TextTicket.png',
    recommendedResolution: DELIVERY_SCREEN_RESOLUTION
  },
  {
    key: KioskGraphics.DELIVERY_PRINT,
    label: 'Delivery – Print',
    defaultSrc: PrintTicket,
    defaultFileName: 'PrintTicket.png',
    recommendedResolution: TILE_RESOLUTION
  },
  {
    key: KioskGraphics.LOOKUP_SCAN,
    label: 'Lookup – Scan',
    defaultSrc: BarcodeScan,
    defaultFileName: 'barcode_scan.png',
    // larger of the lookup tile and the scan screen (fixed 538px height, 4:3)
    recommendedResolution: '717px by 538px'
  },
  {
    key: KioskGraphics.LOOKUP_MANUAL,
    label: 'Lookup – Manual',
    defaultSrc: CustomLookup,
    defaultFileName: 'custom_lookup.png',
    recommendedResolution: TILE_RESOLUTION
  },
  {
    key: KioskGraphics.EMPTY_NO_EVENTS,
    label: 'No Events Available',
    defaultSrc: TicketsIcon,
    defaultFileName: 'tickets_icon.png',
    recommendedResolution: '207px by 180px'
  },
  {
    key: KioskGraphics.EMPTY_NO_RESULTS,
    label: 'No Search Results',
    defaultSrc: SearchIcon,
    defaultFileName: 'search_icon.png',
    recommendedResolution: '180px by 180px'
  },
  {
    key: KioskGraphics.PAYMENT_SCREEN,
    label: 'Payment Screen',
    defaultSrc: CreditCardPayment,
    defaultFileName: 'credit_card_payment.svg',
    recommendedResolution: '500px by 538px'
  },
  {
    key: KioskGraphics.IMAGE_FALLBACK,
    label: 'Missing Image Placeholder',
    defaultSrc: WillCallIcon,
    defaultFileName: 'will_call_icon.png',
    // largest use is the event image on ticket selection
    recommendedResolution: 'Landscape: 493px by 370px \nPortrait: 784px by 588px'
  }
];
